import { ILGEChangeCandidate } from "../interfaces/ILGEChangeCandidate";
import { ILGEStaticCandidate } from "../interfaces/ILGEStaticCandidate";
import { LGDocument } from "./LGDocument";

export class LGCandidate {

    private readonly _lgeChangeCandidate: ILGEChangeCandidate | null;
    private readonly _lgeStaticCandidate: ILGEStaticCandidate;
  
    public imageSource: any;
    public isImageLoaded = false;
    public documents: LGDocument[] = [];
    public expand = false;

    constructor(
        lgeChangeCandidate: ILGEChangeCandidate | null,
        lgeStaticCandidate: ILGEStaticCandidate
    ) {
        this._lgeChangeCandidate = lgeChangeCandidate;
        this._lgeStaticCandidate = lgeStaticCandidate;

        this._lgeStaticCandidate.documents.forEach(document => {
            this.documents.push(new LGDocument(document));
        });
        this._lgeChangeCandidate?.documents.forEach(document => {
            this.documents.push(new LGDocument(document));
        });
    }

    get uid(): string {
        return this._lgeStaticCandidate.uid;
    }

    get candidateName(): string {
        return this._lgeStaticCandidate.ballotName;
    }

    get candidateParty(): string {
        return this._lgeStaticCandidate.partyAffiliation;
    }

    get candidatePhotoUrl(): string | null{
        if (this._lgeStaticCandidate.candidatePhotoUrl && this._lgeStaticCandidate.candidatePhotoUrl.length > 4) {
            return this._lgeStaticCandidate.candidatePhotoUrl;
        }
        return null;
    }

    get candidateProfileText(): string {
        return this._lgeStaticCandidate.profileText;
    }   

    get candidateContactDetails(): string {
        return this._lgeStaticCandidate.contactDetails;
    }

    get candidateLiveInTheArea(): string {
        return this._lgeStaticCandidate.liveInTheArea;
    }

    get websiteGrayScale(): string {
        return '1';
    }

    get websiteSepia(): string {
        return '0.2';
    }

    get websiteBrightness(): string {
        if (this._lgeStaticCandidate.photoBrightness > 50) {
            return this._lgeStaticCandidate.photoBrightness.toString();
        }
        return '100';
    }

    get documentCount(): number {
        return this.documents.length;
    }

    get firstPreferenceCount(): number {
        return this._lgeChangeCandidate?.firstPrefVotes ?? 0;
    }

    get isElected(): boolean {
        return this._lgeChangeCandidate?.isElected ?? false;
    }

    get orderOfElection(): number {
        return this._lgeChangeCandidate?.orderOfElection ?? 0;
    }

    get votesAtConclusion(): number {
        return this._lgeChangeCandidate?.votesAtConclusion ?? 0;
    }

    get countNo(): number {
        return this._lgeChangeCandidate?.countNo ?? 0;
    }
    
}